import { useCallback, useRef } from 'react'
import { gtmGtag } from '@/services/gtm'
import { parseOneTrustConsentGroups } from '@/utils/parseOneTrustConsentGroups'

export type OneTrustApi = {
  OnConsentChanged: (callback: () => void) => void
  IsAlertBoxClosed: () => boolean
  AllowAll: () => void
  RejectAll: () => void
  ToggleInfoDisplay: () => void
  SetAlertBoxClosed: () => void
}

export function useSaveConsent() {
  const calledRef = useRef(false)
  const saveConsent = useCallback(() => {
    if (calledRef.current) return

    const consentGroups = parseOneTrustConsentGroups()
    if (consentGroups == null) return
    gtmGtag('consent', 'update', {
      ad_storage: consentGroups.targeting,
      ad_user_data: consentGroups.targeting,
      ad_personalization: consentGroups.targeting,
      analytics_storage: consentGroups.performance,
      personalization_storage: consentGroups.required,
      functionality_storage: consentGroups.required,
      security_storage: consentGroups.required,
    })
  }, [])

  return saveConsent
}
